/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useRef, useContext, useEffect } from "react";
import { Loader } from "@progress/kendo-react-indicators";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { API_URL } from "utils/constant";
import { UserContext } from "utils/reducers/user";
import httpClient from "utils/apis/http-client";
import { isOperationAllowed, showToast } from "utils/helper";
import Layout from "components/layout";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  Combobox,
  DatePicker,
} from "@repo/ui";
import { Link } from "react-router-dom";
import {
  useGetDispatchedTeam,
  useGetUsersByRole,
} from "utils/apis/lookups.api";
import {
  useGetDailyRouteService,
  useUpdateTeamMembers,
} from "utils/apis/store.api";
import TeamInfoCard from "./team-info-card";
import { formatDate } from "date-fns";
import { Permissions } from "utils/enums";

const apiUrl = API_URL;

const verificationEndpoint = `${apiUrl}/daily/operations/check/team/member/assignment`;

function FieldTeamManagement() {
  const user = useContext(UserContext);
  const currentDate = new Date();

  const [ddlRoutes, setDdlRoutes] = useState("");
  const [routeNo, setRouteNo] = useState("");
  const [teamMembersCount, setTeamMembersCount] = useState<any>(0);
  const [nationalityCount, setNationalityCount] = useState<any>(0);
  const [oldFieldTeam, setOldFieldTeam] = useState<any>([]);

  const [ddlTeamLeaders, setDdlTeamLeaders] = useState("");
  const [ddlDrivers, setDdlDrivers] = useState("");
  const [ddlGuards, setDdlGuards] = useState("");
  const [ddlGuards2, setDdlGuards2] = useState("");

  const [isValidTeam, setIsValidTeam] = useState(true);
  const [newFieldTeam, setNewFieldTeam] = useState<any>([]);
  const [operationDate, setOperationDate] = useState(currentDate);

  const [btnConfirmText, setBtnConfirmText] = useState(
    "Confirm Team Assignment",
  );
  const [btnConfirmDisabled, setBtnConfirmDisabled] = useState(true);

  const teamMembersList = useRef<any>([]);

  const { data: teamLeaders } = useGetUsersByRole(
    user.CashCenterId,
    "Team Leader",
  );
  const { data: drivers } = useGetUsersByRole(user.CashCenterId, "Driver");
  const { data: guards } = useGetUsersByRole(user.CashCenterId, "Guard");
  const { data: routes } = useGetDispatchedTeam({
    cashCenterId: user.CashCenterId,
    shift: "morning",
    operationDate: formatDate(
      operationDate || currentDate,
      "yyyy-MM-dd'T'00:00:00.000'Z'",
    ),
  });

  const onDdlRoutesChanged = (value: string) => {
    if (!value) {
      setDdlRoutes("");
      return;
    }

    setDdlRoutes(value);

    const selectedRoute = routes?.find((item) => item.routeNo === value);
    const { fieldTeam, routeNo, requiredTeamMembers, teamNationalityCount } =
      selectedRoute;

    const otm: any = [...fieldTeam];

    setOldFieldTeam(otm);
    setNewFieldTeam(fieldTeam);
    setRouteNo(routeNo);
    setTeamMembersCount(requiredTeamMembers);
    setNationalityCount(teamNationalityCount);

    teamMembersList.current = fieldTeam;

    const currentLeader = fieldTeam.find(
      (ft: any) => ft.role === "Team Leader",
    );

    if (currentLeader) {
      setDdlTeamLeaders(currentLeader.employeeId);
    }

    const currentDriver = fieldTeam.find((ft: any) => ft.role === "Driver");

    if (currentDriver) {
      setDdlDrivers(currentDriver.employeeId);
    }

    const guards = fieldTeam.filter((ft: any) => ft.role === "Guard");

    if (guards.length > 1) {
      const guard1 = guards[0];
      const guard2 = guards[1];

      setDdlGuards(guard1.employeeId);

      setDdlGuards2(guard2.employeeId);
    } else if (guards.length === 1) {
      const guard1 = guards[0];
      setDdlGuards(guard1.employeeId);
    }
  };

  const validateFieldTeam = async (
    teamList: any,
    requiredTeamMembers: any,
    maxCoNationalsCount: any,
  ) => {
    const validationEndpoint = `${apiUrl}/daily/operations/validate/field/team`;

    const validationDto = {
      requiredTeamMembers,
      maxCoNationalsCount,
      fieldTeam: teamList,
    };

    await httpClient
      .post(validationEndpoint, validationDto)
      .then((res) => {
        if (res.status == 200) {
          const result = res.data;

          if (result == false) setIsValidTeam(false);
          else setIsValidTeam(true);
        } else {
          setIsValidTeam(false);
          showToast("error", "Failed to validate field team.");
        }
      })
      .catch(() => {
        setIsValidTeam(false);
        showToast("error", "Failed to validate field team.");
      });
  };

  const { data: requests, isPending: isLoading } = useGetDailyRouteService({
    cashCenterId: user.CashCenterId,
    operationDate: formatDate(
      operationDate || currentDate,
      "yyyy-MM-dd'T'00:00:00.000'Z'",
    ),
    routeNo,
  });

  const onOperationDateChanged = (value: any) => {
    const opsDate = value;
    setOperationDate(opsDate as Date);
  };

  const onTeamMemberSelected = async (teamMember: any) => {
    const { employeeId, role } = teamMember;

    if (!employeeId) {
      const memberToRemove = teamMembersList.current.findIndex(
        (tm: any) => tm.role === role,
      );
      teamMembersList.current.splice(memberToRemove, 1);
    } else {
      const teamDto = {
        cashCenterId: user.CashCenterId,
        operationDate: formatDate(
          operationDate || currentDate,
          "yyyy-MM-dd'T'00:00:00.000'Z'",
        ),
        assigneeId: employeeId,
      };

      await httpClient
        .post(verificationEndpoint, teamDto)
        .then((res) => {
          if (res.status === 200) {
            const result = res.data;
            const selectedRoute = routes?.find(
              (item) => item.routeNo === ddlRoutes,
            );

            if (result == false) {
              if (role === "Team Leader" || role === "Driver") {
                const teamMemberFound = teamMembersList.current.find(
                  (tm: any) => tm.role === role,
                );

                if (teamMemberFound) {
                  const memberToRemove = teamMembersList.current.findIndex(
                    (tm: any) => tm.role === role,
                  );
                  teamMembersList.current.splice(memberToRemove, 1);
                }
              } else if (selectedRoute?.requiredTeamMembers > 3) {
                const guardsCount = teamMembersList.current.filter(
                  (tm: any) => tm.role === role,
                );

                if (guardsCount.length > 1) {
                  teamMembersList.current.shift();
                }
              } else {
                const teamMemberFound = teamMembersList.current.find(
                  (tm: any) => tm.role === role,
                );

                if (teamMemberFound) {
                  const memberToRemove = teamMembersList.current.findIndex(
                    (tm: any) => tm.role === role,
                  );
                  teamMembersList.current.splice(memberToRemove, 1);
                }
              }

              teamMembersList.current.push(teamMember);

              const teamList: any = [];

              teamMembersList.current.forEach((tm: any) => {
                teamList.push(tm);
              });

              setNewFieldTeam(teamList);

              validateFieldTeam(
                teamList,
                selectedRoute?.requiredTeamMembers,
                selectedRoute?.teamNationalityCount,
              );

              if (teamList.length === selectedRoute?.requiredTeamMembers)
                setBtnConfirmDisabled(false);
              else setBtnConfirmDisabled(true);
            } else {
              showToast("error", "Selected team leader is already assigned.");
              setBtnConfirmDisabled(true);
            }
          }
        })
        .catch(() => {
          showToast("error", "Selected team leader is already assigned.");
          setBtnConfirmDisabled(true);
        });
    }
  };

  const onDdlTeamLeaderChanged = (value: string) => {
    setDdlTeamLeaders(value);
    const selectedLeader = teamLeaders?.find(
      (item: any) => item?.employeeId === value,
    );
    const teamMember = {
      ...selectedLeader,
      role: "Team Leader",
    };

    onTeamMemberSelected(teamMember);
  };

  const onDdlDriverChanged = (value: string) => {
    setDdlDrivers(value);
    const selectedDriver = drivers?.find(
      (item: any) => item?.employeeId === value,
    );
    const teamMember = {
      ...selectedDriver,
      role: "Driver",
    };

    onTeamMemberSelected(teamMember);
  };

  const onDdlGuardChanged = (value: string) => {
    setDdlGuards(value);
    const selectedGuard = guards?.find(
      (item: any) => item?.employeeId === value,
    );
    const teamMember = {
      ...selectedGuard,
      role: "Guard",
    };

    onTeamMemberSelected(teamMember);
  };

  const onDdlGuard2Changed = (value: string) => {
    setDdlGuards2(value);
    const selectedGuard = guards?.find(
      (item: any) => item?.employeeId === value,
    );
    const teamMember = {
      ...selectedGuard,
      role: "Guard",
    };

    onTeamMemberSelected(teamMember);
  };

  function PriorityButtonCell({ dataItem }: any) {
    const { priority } = dataItem;

    let btnColor = "bg-green-500";

    if (priority === "High") btnColor = "bg-red-500";

    if (priority === "Low") btnColor = "bg-yellow-500";

    return (
      <td className={btnColor} style={{ border: "solid white 0.0625rem" }}>
        <span className="w-full block text-center text-white font-semibold">
          {priority}
        </span>
      </td>
    );
  }

  const {
    mutate: updateTeam,
    isSuccess: updateSuccess,
    isError: updateError,
  } = useUpdateTeamMembers();

  const onBtnConfirmClicked = () => {
    if (newFieldTeam.length === 0) {
      showToast("error", "No team member selected.");
      return;
    }

    const requestIds = requests?.map((sr: any) => ({
      requestId: sr.requestId,
      jobNo: sr.jobNo,
      serviceType: sr.serviceType,
    }));

    const cashCenterId = user.CashCenterId;

    const assignmentDto = {
      cashCenterId,
      shift: "morning",
      operationDate: formatDate(
        operationDate || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'",
      ),
      requests: requestIds,
      oldFieldTeam,
      newFieldTeam,
    };

    setBtnConfirmDisabled(true);
    setBtnConfirmText("Confirming.....");
    updateTeam(assignmentDto);
  };

  useEffect(() => {
    if (updateSuccess) {
      setDdlRoutes("");
      setNewFieldTeam([]);
      teamMembersList.current = [];
      setOldFieldTeam([]);
      setBtnConfirmText("Confirm Team Assignment");
    }
    if (updateError) {
      setBtnConfirmDisabled(false);
      setBtnConfirmText("Confirm Field Assignment");
    }
  }, [updateSuccess, updateError]);
  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Field Team Management</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card className="mx-4 mt-5">
        <CardContent className="pt-6">
          <div className="flex gap-4">
            <div className="w-[25%]">
              <DatePicker
                className="w-100"
                selectedDate={operationDate}
                onSelectDate={onOperationDateChanged}
              />
            </div>

            {isOperationAllowed(Permissions.Team, Permissions.Edit) ? (
              <div className="w-[25%]">
                <Combobox
                  value={ddlRoutes}
                  data={routes?.map((u: any) => ({
                    value: u.routeNo,
                    label: `${u.routeNo} (${u.description})`,
                  }))}
                  placeholder="Select Dispatched Route"
                  setValue={onDdlRoutesChanged}
                />
              </div>
            ) : null}

            <div className="w-[15%]">
              {isLoading ? (
                <div className="text-center" style={{ marginTop: -10 }}>
                  <Loader size="large" type="pulsing" />
                </div>
              ) : null}
            </div>

            {isOperationAllowed(Permissions.Team, Permissions.Edit) ? (
              <div className="w-[35%]">
                <Button
                  variant="secondary"
                  className="flex w-max ml-auto"
                  disabled={btnConfirmDisabled || !isValidTeam}
                  onClick={onBtnConfirmClicked}
                >
                  {btnConfirmText}
                </Button>
              </div>
            ) : null}
          </div>
          <div className="border-b my-3 bg-accent" />
          {ddlRoutes && newFieldTeam.length > 0 ? (
            <>
              <div className="flex">
                <div className="flex-1">
                  <span className="font-medium leading-none text-lg">
                    Field Team
                  </span>
                </div>
                <div className="flex-1">
                  <span className="font-medium leading-none text-lg">
                    {`Route No: ${routeNo}`}
                  </span>
                </div>
                <div className="flex-1">
                  <span className="font-medium leading-none text-lg">
                    {`Required Team Members: ${teamMembersCount}`}
                  </span>
                </div>

                <div className="flex-1">
                  <span className="font-medium leading-none text-lg">
                    {`Nationality Distribution: ${nationalityCount}`}
                  </span>
                </div>
              </div>

              <div className="border-b my-3 bg-accent" />

              <div className="flex mb-3 gap-4">
                {newFieldTeam.map((ft: any) => {
                  return <TeamInfoCard key={ft} team={ft} />;
                })}
              </div>
            </>
          ) : null}

          {ddlRoutes ? (
            <>
              <h4 className="mb-3 font-medium leading-none text-lg">
                Select New Field Team
              </h4>
              {!isValidTeam && (
                <p className="mb-3 font-medium leading-none text-sm text-yellow-600">
                  Selected field team violates nationality distribution rules,
                  double check to proceed further!
                </p>
              )}
              <div className="border-b my-3 bg-accent" />
              <div className="flex gap-4">
                <div className="flex-1">
                  <label className="mb-2 block font-medium leading-none">
                    Team Leader
                  </label>
                  <Combobox
                    value={ddlTeamLeaders}
                    data={teamLeaders?.map((u: any) => ({
                      value: u.employeeId,
                      label: `${u.name} (${u.nationality})`,
                    }))}
                    placeholder="Select Team Leader"
                    setValue={onDdlTeamLeaderChanged}
                  />
                </div>

                <div className="flex-1">
                  <label className="mb-2 block font-medium leading-none">
                    Driver
                  </label>
                  <Combobox
                    value={ddlDrivers}
                    data={drivers?.map((u: any) => ({
                      value: u.employeeId,
                      label: `${u.name} (${u.nationality})`,
                    }))}
                    placeholder="Select Driver"
                    setValue={onDdlDriverChanged}
                  />
                </div>

                <div className="flex-1">
                  <label className="mb-2 block font-medium leading-none">
                    Guard
                  </label>
                  <Combobox
                    value={ddlGuards}
                    data={guards?.map((u: any) => ({
                      value: u.employeeId,
                      label: `${u.name} (${u.nationality})`,
                    }))}
                    placeholder="Select Guard"
                    setValue={onDdlGuardChanged}
                  />
                </div>

                <div className="flex-1">
                  {ddlRoutes && teamMembersCount > 3 ? (
                    <>
                      <label className="mb-2 block font-medium leading-none">
                        Guard 2
                      </label>
                      <Combobox
                        value={ddlGuards2}
                        data={guards?.map((u: any) => ({
                          value: u.employeeId,
                          label: u.name,
                        }))}
                        placeholder="Select Guard 2"
                        setValue={onDdlGuard2Changed}
                      />
                    </>
                  ) : null}
                </div>
              </div>

              <div className="border-b my-3 bg-accent" />

              <label className="mb-3 block font-medium leading-none text-lg">
                In Route Services
              </label>

              <div className="flex mt-2">
                <div className="cols-12">
                  <Grid data={requests || []} scrollable="scrollable">
                    <Column
                      field="jobNo"
                      title="Job No"
                      className="text-center"
                      width="80"
                    />
                    <Column
                      field="locationId"
                      title="Location Id"
                      width="140"
                    />
                    <Column
                      field="locationName"
                      title="Location Name"
                      width="200"
                    />
                    <Column
                      field="onwardLocationId"
                      title="Onward Location Id"
                    />
                    <Column
                      field="destination"
                      title="Onward Location"
                      width="200"
                    />
                    <Column
                      field="jobType"
                      title="Job Type"
                      className="text-center"
                      width="140"
                    />
                    <Column
                      field="routeNo"
                      title="Route No"
                      className="text-center"
                      width="140"
                    />
                    <Column
                      field="status"
                      title="Status"
                      className="text-center"
                      width="140"
                    />
                    <Column field="remarks" title="Remarks" />
                    <Column
                      width="80"
                      title="Priority"
                      className="text-center"
                      cell={PriorityButtonCell}
                      filterable={false}
                    />
                  </Grid>
                </div>
              </div>
            </>
          ) : null}
        </CardContent>
      </Card>
    </Layout>
  );
}

export default FieldTeamManagement;
